import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Drawer,
    Grid,
    IconButton,
    Snackbar,
    Tab,
    Tabs,
    Typography,
    MenuItem,
    Select,
    TextField,
    Badge,
    Avatar,
    Fab,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@mui/material";
import {S3_URL} from "../config";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CloseIcon from '@mui/icons-material/Close';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import FastfoodIcon from '@mui/icons-material/Fastfood';
//import FastfoodIcon from '../images/snacks.png';
import EggIcon from '@mui/icons-material/Egg';
import React, { useEffect, useState } from 'react';
import FoodImage from "../images/food.jpeg";
import ShoppingBagIcon from '../images/shoppingbag.png';
import whatsInsideBoxIcon from '../images/whatsinside.png';
import {resolvePath, useLocation} from 'react-router-dom';
import axiosInstance from "../axiosConfig";
import CartDialog from "./CartDialog";
import {LocalDrink} from "@mui/icons-material";

export default function ProductMenu() {
    const S3_URL = process.env.S3_URL;
    const [tabIndex, setTabIndex] = useState(0);
    const location = useLocation();
    const [openDialog, setOpenDialog] = useState(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const tab = parseInt(queryParams.get('tab'), 10);
        if (!isNaN(tab)) {
            setTabIndex(tab);
        }
    }, [location]);

    const [cart, setCart] = useState({});
    const [cartOpen, setCartOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [openCartDialog, setOpenCartDialog] = useState(false);

    const [selectedBoxContent, setSelectedBoxContent] = useState('');

    const handleAddToCart = (title, price,id,contents) => {
        setCart((prevCart) => ({
            ...prevCart,
            [title]: {
                quantity: (prevCart[title]?.quantity || 0) + 1,
                price,
                id,
                contents
            }
        }));
    };

    const handleOpenDialog = (content) => {
        console.log("before opening the dialog box",content);
        setSelectedBoxContent(content);
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleRemoveFromCart = (title) => {
        setCart((prevCart) => {
            const newCart = { ...prevCart };
            if (newCart[title]?.quantity > 1) {
                newCart[title].quantity -= 1;
            } else {
                delete newCart[title];
            }
            return newCart;
        });
    };

    const handleCartOpen = () => setCartOpen(true);
    const handleCartClose = () => setCartOpen(false);
    const handleCartDialogOpen = () => setOpenCartDialog(true);

    const handlePreOrder = () => {
        console.log('Cart:', cart);
    };

    const totalPrice = Object.values(cart).reduce((sum, item) => sum + (item.quantity * parseFloat(item.price)), 0);
    const totalItems = Object.values(cart).reduce((sum, item) => sum + item.quantity, 0);

    return (
        <Box sx={{ width: "100%", padding: 2, marginTop: '64px' }}>
            {/* Responsive Tabs */}
            <Box sx={{ display: { xs: 'none', md: 'block' }, borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={tabIndex} onChange={(e, value) => setTabIndex(value)}>
                    <Tab label="Dinner Box" icon={<DinnerDiningIcon />} />
                    <Tab label="Snacks Box" icon={<FastfoodIcon />} />
                    <Tab label="Breakfast Box" icon={<EggIcon />} />
                    <Tab label="Drink Box" icon={<LocalDrink />} />

                </Tabs>
            </Box>

            {/* Floating Tabs for Mobile */}
            <Box sx={{ position: 'fixed', top: '50%', right: 16, zIndex: 1000, display: { xs: 'flex', md: 'none' }, flexDirection: 'column', gap: 1 }}>
                <Fab size="small" color={tabIndex === 0 ? "primary" : "default"} onClick={() => setTabIndex(0)}>
                    <DinnerDiningIcon />
                </Fab>
                <Fab size="small" color={tabIndex === 1 ? "primary" : "default"} onClick={() => setTabIndex(1)}>
                    <FastfoodIcon />
                </Fab>
                <Fab size="small" color={tabIndex === 2 ? "primary" : "default"} onClick={() => setTabIndex(2)}>
                    <EggIcon />
                </Fab>
                <Fab size="small" color={tabIndex === 3 ? "primary" : "default"} onClick={() => setTabIndex(3)}>
                    <LocalDrink />
                </Fab>
            </Box>


            <Box sx={{ marginTop: 2 }}>
                {tabIndex === 0 && <ProductBox cart={cart} onAdd={handleAddToCart} onRemove={handleRemoveFromCart} onOpenDialog={handleOpenDialog} category="dinner" title="Wholesome Dinners, Zero Hassle! Pre-Order"/>}
                {tabIndex === 1 && <ProductBox cart={cart} onAdd={handleAddToCart} onRemove={handleRemoveFromCart} onOpenDialog={handleOpenDialog} category="snacks" title="Munch on Tradition! Pre-Order Now!" />}
                {tabIndex === 2 && <ProductBox cart={cart} onAdd={handleAddToCart} onRemove={handleRemoveFromCart} onOpenDialog={handleOpenDialog} category="batters" title="Stress-Free Mornings! Pre-Order"/>}
                {tabIndex === 3 && <ProductBox cart={cart} onAdd={handleAddToCart} onRemove={handleRemoveFromCart} onOpenDialog={handleOpenDialog} category="drinks" title="Thirsty ? Grab Me"/>}
            </Box>

            <IconButton
                onClick={handleCartDialogOpen}
                color="primary"
                sx={{
                    position: 'fixed',
                    bottom: 16,
                    right: 16,
                    zIndex: 1000,
                    backgroundColor: '#fff',
                    boxShadow: 3,
                    borderRadius: '50%',
                    '&:hover': {
                        backgroundColor: '#f0f0f0'
                    }
                }}
            >
                <Badge
                    badgeContent={totalItems}
                    color="secondary"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                >
                    <Avatar src={ShoppingBagIcon} alt="Cart" sx={{ width: 50, height: 50 }} />
                </Badge>
            </IconButton>
            <CartDrawer
                cart={cart}
                onClose={handleCartClose}
                open={cartOpen}
                onPreOrder={handlePreOrder}
                totalPrice={totalPrice}
                onOpenDialog={handleOpenDialog}
            />
            <CartDialog
                open={openCartDialog}
                onClose={() => setOpenCartDialog(false)}
                cart={cart}
                setCart={setCart}
                totalPrice={totalPrice}
                handlePreOrder={handlePreOrder}
            />
            <Dialog open={dialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>
                    What's Inside
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseDialog}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {/* Split the contents and display in separate lines */}
                    {selectedBoxContent?.split(',').map((item, index) => (
                        <Typography key={index} sx={{ marginBottom: 1 }}>
                            • {item.trim()}
                        </Typography>
                    ))}
                </DialogContent>

            </Dialog>
        </Box>

    );
}


const CartDrawer = ({ cart, onClose, open, onPreOrder, totalPrice, onOpenDialog }) => {
    const [pickupLocation, setPickupLocation] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');

    const handlePreOrder = async () => {
        const orderDetails = {
            customer: {
                name,
                email,
                phone,
                pickupLocation,
            },
            cart: Object.entries(cart).map(([item, details]) => ({
                title: item,
                quantity: details.quantity,
                price: details.price,
                contents: details.contents,
                id: details.id, // Include ID in order details
            })),
            totalPrice
        };

        try {
            const response =  await axiosInstance.post(`/preorderbox/customer`, {
                ...orderDetails// Set current datetime
            });
            const orderId = response.data; // Capture order ID from backend
            onOpenDialog(`Order #${orderId} was placed successfully!`);
            setTimeout(() => {
                onClose(); // Close drawer after submission
                clearCart(); // Clear cart after successful submission
            }, 3000);
        } catch (error) {
            console.error('Failed to place order:', error);
            onOpenDialog('Failed to place order. Please try again.');
        }
    };

    const clearCart = () => {
        Object.keys(cart).forEach((key) => delete cart[key]);
    };

    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ width: 350, height: '100%', display: 'flex', flexDirection: 'column' }}>
                {/* Header */}
                <Box sx={{ padding: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #ddd' }}>
                    <Typography variant="h6">Shopping Bag</Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Cart Items */}
                <Box sx={{ overflowY: 'auto', flexGrow: 1, padding: 2 }}>
                    {Object.entries(cart).map(([item, details]) => (
                        <Box key={item} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 1, padding: 1, borderBottom: '1px solid #ddd' }}>
                            <Typography>{item} ({details.quantity})</Typography>
                            <Typography>${(details.quantity * parseFloat(details.price)).toFixed(2)}</Typography>
                        </Box>
                    ))}
                </Box>

                {/* Order Details */}
                <Box sx={{ padding: 2, borderTop: '1px solid #ddd' }}>
                    {/* Total Price */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 1, padding: 1, borderBottom: '1px solid #ddd' }}>
                        <Typography variant="h6" sx={{ marginTop: 2 }}>Total Price:</Typography>
                        <Typography variant="h6" sx={{ marginTop: 2 }}>${totalPrice.toFixed(2)}</Typography>
                    </Box>

                    {/* Pickup Location */}
                    <Select
                        value={pickupLocation}
                        onChange={(e) => setPickupLocation(e.target.value)}
                        displayEmpty
                        fullWidth
                        required
                        sx={{ marginTop: 2 }}
                    >
                        <MenuItem value="">Select Pickup Location</MenuItem>
                        <MenuItem value="2436 Flower Petal Rd, Frisco Tx 75033">Holly Hock , Frisco, Tx </MenuItem>
                        <MenuItem value="800 W Eldorado Pkwy #128, Little Elm, TX 75068">Nags Kitchen , Little Elm, Tx</MenuItem>
                        <MenuItem value="800 W Eldorado Pkwy #128, Little Elm, TX 75068">PCR, Frisco , Tx</MenuItem>
                    </Select>

                    {/* Customer Details */}
                    <TextField
                        label="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        fullWidth
                        required
                        sx={{ marginTop: 2 }}
                    />
                    <TextField
                        label="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        required
                        sx={{ marginTop: 2 }}
                    />
                    <TextField
                        label="Phone Number"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        fullWidth
                        required
                        sx={{ marginTop: 2 }}
                    />

                    {/* Submit Button */}
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={handlePreOrder}
                        sx={{ marginTop: 2 }}
                    >
                        Pre-Order Now
                    </Button>
                </Box>
            </Box>
        </Drawer>
    );
};

const ProductBox = ({ cart, onAdd, onRemove ,onOpenDialog,category,title}) => {

    const [products, setProducts] = useState([]);
    useEffect(() => {
        axiosInstance.get(`/preorderbox/category/${category}`).then(response => setProducts(response.data));
    }, []);

    return (
        <Container>
            <Typography variant="h4" gutterBottom sx={{
                wordWrap: 'break-word',
                overflowWrap: 'break-word',
                [theme => theme.breakpoints.down('sm')]: {
                    fontSize: '1.5rem'  // Adjust font size for smaller screens
                }
            }} align="center">{title}</Typography>
            <Grid container spacing={4} justifyContent="center">
                {products.map((item, index) => (

                    <Grid item key={index} xs={12} sm={6} md={3}>
                        <Card sx={{ borderRadius: '24px', boxShadow: 3, height: '420px',maxWidth: '275px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
                            <CardMedia
                                component="img"
                                height="180"
                                image={`${S3_URL}${item.image}`}//
                                alt={item.title}
                                sx={{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }}
                            />
                            <CardContent sx={{ padding: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1 }}>
                                <Typography variant="h5" gutterBottom>{item.title}<Typography variant="h6" color="primary">${item.price}</Typography></Typography>
                                <Typography variant="body2" gutterBottom>{item.description}</Typography>
                                <Box display="flex" alignItems="center" gap={1} sx={{ marginTop: 'auto', position: 'absolute', bottom: 8, left: '50%', transform: 'translateX(-50%)' }}>
                                    <IconButton onClick={() => onRemove(item.title)} sx={{ backgroundColor: '#f0f0f0', borderRadius: '50%' }}>
                                        <RemoveIcon />
                                    </IconButton>
                                    <Typography variant="h6">{cart[item.title]?.quantity || 0}</Typography>
                                    <IconButton onClick={() => onAdd(item.title, item.price,item.id,item.contents)} sx={{ backgroundColor: '#f0f0f0', borderRadius: '50%' }}>
                                        <AddIcon />
                                    </IconButton>
                                    <IconButton onClick={() => onOpenDialog(item.contents)}>
                                        <CardMedia
                                            component="img"
                                            sx={{
                                                height: { xs: '48px', sm: '72px' }, // Responsive height
                                                width: { xs: '24px', sm: '40px' }, // Responsive width
                                                objectFit: 'contain' // Ensures the image scales without distortion
                                            }}
                                            image={require('../images/whatsinside.png')}
                                            alt="info"
                                        />
                                    </IconButton>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>

        </Container>
    );
};


